import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import useTimeStore from '../ZustandProvider';

const MapLayerControlSideBySide = () => {
  const layerSide = useTimeStore(state => state.layerSide);
  const setLayerSide = useTimeStore(state => state.setLayerSide);
  const layers = useTimeStore(state => state.layers);
  const filteredLayers = layers.filter(layer => ['WMS', 'WMTS'].includes(layer.layerSubType));

  const handleLayer = (event, side) => {
    setLayerSide({
      ...layerSide,
      [side]: event.target.value
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Layer left</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Layer left"
            size="small"
            value={layerSide.left || ''}
            onChange={event => handleLayer(event, 'left')}
          >
            {filteredLayers.map(item => (
              <MenuItem key={item._id} value={item._id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Layer right</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Layer right"
            size="small"
            value={layerSide.right || ''}
            onChange={event => handleLayer(event, 'right')}
          >
            {filteredLayers.map(item => (
              <MenuItem key={item._id} value={item._id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default MapLayerControlSideBySide;
MapLayerControlSideBySide.defaultProps = {};
MapLayerControlSideBySide.propTypes = {};
